__turbopack_context__.v({
  "eyebrow": "CustomSoftwareIntegrationServicesCardSection-module__a-ynqW__eyebrow",
  "heading": "CustomSoftwareIntegrationServicesCardSection-module__a-ynqW__heading",
  "section": "CustomSoftwareIntegrationServicesCardSection-module__a-ynqW__section",
  "title": "CustomSoftwareIntegrationServicesCardSection-module__a-ynqW__title",
});
